// export const BASEURL = 'http://192.168.0.198:4999'
// export const BASEURL = 'http://localhost:4003'
// export const BASEURL = 'https://westudyapp.com'
// export const BASEURL = 'https://westudyapp.com'
export const BASEURL = window.location.origin
export const FILEURL = 'https://object-storage-bucket.us-east-1.linodeobjects.com'